import {pageRedirectMainLogout} from "@helpers/router-helper";
import { component } from 'vue';

const page = (page) => async () => await import(`../pages/${page}/${page}`);

export default [
    {
        path: '/',
        name: 'root',
        redirect: '/auth'
    },
    {
        path: '/register',
        name: 'register',
        redirect: '/auth',
    },
    {
        path: '/partner/skyslopeInvitation',
        name: 'skyslope-Invitation',
        component: page("skySlopeInvitation"),
        meta: {layout: 'Basic'},
       
    },
    {
        path: '/partner/skyslopeInvitation2',
        name: 'skyslope-Invitation2',
        component: page('SkySlopeInvitation2'),
        meta: {layout: 'Basic'},
    },
    {
        path: '/partner/skyslopeInvitation-iframetest',
        name: 'skyslope-Invitation-iframe',
        component: page('PartnerTest'),
        meta: {layout: 'Basic'},
    },
    {
        path: '/invalid-invitation',
        name: 'invalid-invitation',
        component: page('InvalidInvitation'),
        meta: {layout: 'Basic', requireUnAuth: true}
    },
    {
        path: '/auth',
        name: 'auth',
        component: page('Auth'),
        meta: {layout: 'Basic', requireUnAuth: true},
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: page('ForgotPassword'),
        meta: {layout: 'Basic'},
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: page('ForgotPassword'),
        meta: {layout: 'Basic'},
        props: true
    },
    {
        path: '/disclosure/:disclosureUuid/order/:orderUuid/sign/:sellerUuid',
        name: 'sign-disclosure',
        component: page('SecondarySellerSignature'),
        meta: {layout: 'Basic'},
        props: true
    },
    {
        path: '/download-pdfs',
        name: 'download-pdfs',
        component: page('SecondarySellerSignature'),
        meta: {layout: 'Basic'},
        props: {fromEmail: true}
    },
    {
        path: '/escrow/officer/invoice',
        name: 'escrow-officer-invoice',
        component: page('EscrowInvoice'),
        meta: {layout: 'Basic'},
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter: async () => await pageRedirectMainLogout(),
    },
    {
        path: '/:notFound(.*)',
        name: 'not-found',
        component: () => import('../pages/Errors/NotFound'),
        meta: {layout: 'Basic'},
    }
];
